<template>
  <div class="unscheduled">
    <h3 class="unscheduled-heading">Unscheduled Production</h3>

    <div class="bucket-section">
      <h4 class="bucket-heading sales-heading">Sales Required</h4>
      <draggable
        v-model="salesOrders"
        :group="{ name: 'orders', pull: 'clone', put: false }"
        item-key="item_no"
        @start="onDragStart"
        @end="onDragEnd"
        class="draggable-container"
      >
        <template #item="{ element }">
          <div
            v-if="element"
            :key="`${element.item_no}-${element.ord_qty}-${element.unscheduled_bucket}`"
            class="work-order"
            :data-part-number="element.item_no"
            :data-ord-qty="element.ord_qty"
            :data-req-ship-dt="element.req_ship_dt"
            :data-unscheduled-bucket="element.unscheduled_bucket"
          >
            <span
              class="unscheduled-item-number"
              :class="getUnscheduledItemClass(element)"
            >
              {{ element.item_no }}
            </span>
            <span
              class="unscheduled-detail unscheduled-qty"
              :class="{
                'max-inventory-warning':
                  element.max_inventory_warning
              }"
              :title="
                element.max_inventory_warning
                  ? (
                      element.max_inventory_message ||
                      'Maximum Warehouse Quantity reached'
                    )
                  : ''
              "
            >
              Qty: {{ Math.round(element.ord_qty) }}
            </span>

            <span
              v-if="element.days_on_hand != null"
              class="unscheduled-detail unscheduled-meta"
            >
              DOH: {{ Number(element.days_on_hand).toFixed(1) }}
            </span>

            <span class="unscheduled-detail unscheduled-date">
              {{
                element.req_ship_dt
                  ? new Date(element.req_ship_dt).toLocaleDateString()
                  : "Forecasted"
              }}
            </span>

            <button
              class="why-button"
              type="button"
              @click.stop="showExplanation(element)"
            >
              ?
            </button>

            <!--<button @click="moveToTrash(element.item_no)">Trash</button>
          -->
          </div>
        </template>
      </draggable>
    </div>

    <div class="bucket-section">
      <div class="sales-plus-heading-row">
        <h4 class="bucket-heading sales-plus-heading">
          Sales+ Required
        </h4>

        <div class="sales-plus-sort-control">

        <span
          class="sales-plus-sort-label"
          :class="{ active: salesPlusSortMode === 'PART_DATE' }"
        >
          Part → Date
        </span>

        <label
          class="sales-plus-sort-switch"
          title="Toggle Sales+ sort"
        >
          <input
            type="checkbox"
            :checked="salesPlusSortMode === 'DATE_PART'"
            @change="onSalesPlusSortToggle"
          />

          <span class="sales-plus-sort-slider"></span>
        </label>

        <span
          class="sales-plus-sort-label"
          :class="{ active: salesPlusSortMode === 'DATE_PART' }"
        >
          Date → Part
        </span>

      </div>

        
      </div>
      <draggable
        :key="`sales-plus-${salesPlusRenderVersion}`"
        :model-value="salesPlusOrders"
        :group="{ name: 'orders', pull: 'clone', put: false }"
        item-key="sales_plus_key"
        :sort="false"
        @start="onDragStart"
        @end="onDragEnd"
        class="draggable-container"
      >
        <template #item="{ element }">
          <div
            v-if="element"
            :key="`${element.item_no}-${element.ord_qty}-${element.unscheduled_bucket}`"
            class="work-order sales-plus-order"
            :data-part-number="element.item_no"
            :data-ord-qty="element.ord_qty"
            :data-req-ship-dt="element.req_ship_dt"
            :data-unscheduled-bucket="element.unscheduled_bucket"
          >
            <span
              class="unscheduled-item-number"
              :class="getUnscheduledItemClass(element)"
            >
              {{ element.item_no }}
            </span>
            <span
              class="unscheduled-detail unscheduled-qty"
              :class="{
                'max-inventory-warning':
                  element.max_inventory_warning
              }"
              :title="
                element.max_inventory_warning
                  ? (
                      element.max_inventory_message ||
                      'Maximum Warehouse Quantity reached'
                    )
                  : ''
              "
            >
              Qty: {{ Math.round(element.ord_qty) }}
            </span>

            <span class="unscheduled-detail unscheduled-date">
              {{
                element.req_ship_dt
                  ? element.req_ship_dt
                  : "Outside Window"
              }}
            </span>

            <span
              v-if="element.demand_bucket"
              class="unscheduled-detail unscheduled-meta"
            >
              {{
                element.demand_bucket === 'UNSCHEDULED_TRUCK'
                  ? 'Truck Unscheduled'
                  : 'Outside Window'
              }}
            </span>

            <button
              class="why-button"
              type="button"
              @click.stop="showExplanation(element)"
            >
              ?
            </button>

            <!--<button @click="moveToTrash(element.item_no)">Trash</button>-->
          </div>
        </template>
      </draggable>
    </div>

    <div class="bucket-section">
      <h4 class="bucket-heading forecast-heading">Forecast Required</h4>
      <draggable
        v-model="forecastOrders"
        :group="{ name: 'orders', pull: 'clone', put: false }"
        item-key="item_no"
        @start="onDragStart"
        @end="onDragEnd"
        class="draggable-container"
      >
        <template #item="{ element }">
          <div
            v-if="element"
            :key="`${element.item_no}-${element.ord_qty}-${element.unscheduled_bucket}`"
            class="work-order"
            :data-part-number="element.item_no"
            :data-ord-qty="element.ord_qty"
            :data-req-ship-dt="element.req_ship_dt"
            :data-unscheduled-bucket="element.unscheduled_bucket"
          >
            <span
              class="unscheduled-item-number"
              :class="getUnscheduledItemClass(element)"
            >
              {{ element.item_no }}
            </span>
            <span
              class="unscheduled-detail unscheduled-qty"
              :class="{
                'max-inventory-warning':
                  element.max_inventory_warning
              }"
              :title="
                element.max_inventory_warning
                  ? (
                      element.max_inventory_message ||
                      'Maximum Warehouse Quantity reached'
                    )
                  : ''
              "
            >
              Qty: {{ Math.round(element.ord_qty) }}
            </span>

            <span
              v-if="element.days_on_hand != null"
              class="unscheduled-detail unscheduled-meta"
            >
              DOH: {{ Number(element.days_on_hand).toFixed(1) }}
            </span>

            <span class="unscheduled-detail unscheduled-date">
              {{
                element.req_ship_dt
                  ? new Date(element.req_ship_dt).toLocaleDateString()
                  : "Forecasted"
              }}
            </span>

            <button
              class="why-button"
              type="button"
              @click.stop="showExplanation(element)"
            >
              ?
            </button>

            <!--<button @click="moveToTrash(element.item_no)">Trash</button>-->
          </div>
        </template>
      </draggable>
    </div>

    <div
      v-if="showWhyModal"
      class="why-modal-overlay"
      @click="closeExplanation"
    >
      <div class="why-modal" @click.stop>
        <h4>Why Pablo Suggested This</h4>

        <div v-if="selectedExplanation">
          <p><strong>Item:</strong> {{ selectedExplanation.item_no || 'N/A' }}</p>
          <p><strong>Bucket:</strong> {{ selectedExplanation.type || selectedOrder?.unscheduled_bucket || 'N/A' }}</p>
          <p><strong>Suggested Qty:</strong> {{ selectedOrder ? Math.round(selectedOrder.ord_qty) : 'N/A' }}</p>

          <p v-if="selectedExplanation.formula">
            <strong>Formula:</strong> {{ selectedExplanation.formula }}
          </p>

          <div v-if="selectedExplanation.type === 'SALES'">
            <p><strong>Sales Demand:</strong> {{ selectedExplanation.sales_demand ?? 'N/A' }}</p>
            <p><strong>On Hand:</strong> {{ selectedExplanation.on_hand ?? 'N/A' }}</p>
            <p><strong>Sales Gap:</strong> {{ selectedExplanation.sales_gap_qty ?? 'N/A' }}</p>
            <p><strong>Open Work Orders:</strong> {{ selectedExplanation.open_work_orders ?? 'N/A' }}</p>
            <p><strong>Req Ship Date:</strong> {{ selectedExplanation.req_ship_dt || 'N/A' }}</p>
          </div>

          <div v-else-if="selectedExplanation.type === 'FORECAST'">
            <p><strong>Recommended Production:</strong> {{ selectedExplanation.recommended_prod ?? 'N/A' }}</p>
            <p><strong>Open Work Orders:</strong> {{ selectedExplanation.open_work_orders ?? 'N/A' }}</p>
            <p><strong>Days on Hand:</strong> {{ selectedExplanation.days_on_hand ?? 'N/A' }}</p>
          </div>

          <div v-else-if="selectedExplanation.type === 'SALES_PLUS'">
            <p><strong>Demand Bucket:</strong> {{ selectedExplanation.demand_bucket || 'N/A' }}</p>
            <p><strong>Sales Demand:</strong> {{ selectedExplanation.sales_demand ?? 'N/A' }}</p>
            <p><strong>On Hand:</strong> {{ selectedExplanation.on_hand ?? 'N/A' }}</p>
            <p><strong>Open Work Orders:</strong> {{ selectedExplanation.open_work_orders ?? 'N/A' }}</p>
            <p><strong>Potential Short:</strong> {{ selectedExplanation.potential_short_qty ?? 'N/A' }}</p>
            <p><strong>Earliest Req Ship Date:</strong> {{ selectedExplanation.earliest_req_ship_dt || 'N/A' }}</p>
            <p><strong>Sales Orders:</strong> {{ selectedExplanation.order_numbers || 'N/A' }}</p>
          </div>

          <p v-if="selectedOrder?.explanation_summary" class="why-summary">
            <strong>Summary:</strong> {{ selectedOrder.explanation_summary }}
          </p>
        </div>

        <div v-else>
          <p>No explanation was provided for this row.</p>
        </div>

        <button type="button" @click="closeExplanation">Close</button>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable';
import axios from 'axios';

export default {
  components: { draggable },
  props: {
    unscheduledOrders: {
      type: Array,
      default: () => []
    },

    salesPlusSortMode: {
      type: String,
      default: 'DATE_PART'
    }
  },

  emits: [
    'sales-plus-sort-change',
    'update-unscheduled',
    'move-to-machine',
    'move-to-trash'
  ],

  data() {
    return {
      localUnscheduledOrders: [...this.unscheduledOrders],

      salesPlusRenderVersion: 0,

      showWhyModal: false,
      selectedExplanation: null,
      selectedOrder: null,

      // Tracks creation of the Pending WO during a drag.
      pendingWorkOrderPromise: null
    };
  },
  computed: {
    salesOrders: {
      get() {
        return this.localUnscheduledOrders.filter(
          order => String(order.unscheduled_bucket || '').toUpperCase() === 'SALES'
        );
      },
      set(newSalesOrders) {
        const otherOrders = this.localUnscheduledOrders.filter(
          order => String(order.unscheduled_bucket || '').toUpperCase() !== 'SALES'
        );
        this.localUnscheduledOrders = [...newSalesOrders, ...otherOrders];
      }
    },

    salesPlusOrders: {
      get() {
        return this.localUnscheduledOrders.filter(
          order => String(order.unscheduled_bucket || '').toUpperCase() === 'SALES_PLUS'
        );
      },
      set(newSalesPlusOrders) {
        const otherOrders = this.localUnscheduledOrders.filter(
          order => String(order.unscheduled_bucket || '').toUpperCase() !== 'SALES_PLUS'
        );
        this.localUnscheduledOrders = [...otherOrders, ...newSalesPlusOrders];
      }
    },

    forecastOrders: {
      get() {
        return this.localUnscheduledOrders.filter(
          order => String(order.unscheduled_bucket || '').toUpperCase() === 'FORECAST'
        );
      },
      set(newForecastOrders) {
        const otherOrders = this.localUnscheduledOrders.filter(
          order => String(order.unscheduled_bucket || '').toUpperCase() !== 'FORECAST'
        );
        this.localUnscheduledOrders = [...otherOrders, ...newForecastOrders];
      }
    }
  },
  watch: {
    unscheduledOrders(newOrders) {
      // Accept the new authoritative array from the parent.
      this.localUnscheduledOrders = [...newOrders];

      const salesPlus = this.localUnscheduledOrders.filter(
        order =>
          String(order.unscheduled_bucket || '').toUpperCase() === 'SALES_PLUS'
      );

      console.log('🟣 CHILD ARRAY RECEIVED');

      console.table(
        salesPlus.slice(0, 15).map((row, index) => ({
          pos: index + 1,
          key: row.sales_plus_key,
          item: row.item_no,
          date: row.req_ship_dt,
          dateRank: row.date_part_rank,
          partRank: row.part_date_rank
        }))
      );

      // IMPORTANT:
      // Rebuild the Sales+ draggable NOW, after the newly sorted
      // Sales+ array has actually arrived.
      this.salesPlusRenderVersion += 1;

      console.log(
        '♻️ SALES+ RENDER VERSION:',
        this.salesPlusRenderVersion
      );

      this.$nextTick(() => {
        const domRows = Array.from(
          this.$el.querySelectorAll(
            '.sales-plus-order[data-sales-plus-key]'
          )
        );

        console.log('🔴 ACTUAL SALES+ DOM ORDER');

        console.table(
          domRows.slice(0, 15).map((el, index) => ({
            pos: index + 1,
            key: el.dataset.salesPlusKey,
            item: el.dataset.partNumber,
            date: el.dataset.reqShipDt
          }))
        );
      });
    }
  },
  mounted() {
    console.log('Fetched unscheduled orders:', this.localUnscheduledOrders);
    this.localUnscheduledOrders.forEach((order, index) => {
      console.log(`Order ${index}:`, order);
    });
  },

  methods: {

    onSalesPlusSortToggle(event) {
      const mode =
        event.target.checked
          ? 'DATE_PART'
          : 'PART_DATE';

      console.log('🟡 TOGGLE CLICKED', {
        mode,
        time: new Date().toISOString()
      });

      this.$emit(
        'sales-plus-sort-change',
        mode
      );
    },
    
    getUnscheduledItemClass(order) {
      const classes = [];

      const itemNo = String(
        order?.item_no ??
        order?.partNumber ??
        ''
      )
        .trim()
        .toUpperCase();

      const productType = String(
        order?.product_type ??
        order?.type ??
        ''
      )
        .trim()
        .toUpperCase();

      let rValue = '';

      const rawRValue =
        order?.r_value ??
        order?.rValue ??
        '';

      const numericRValue = Number(rawRValue);

      if (Number.isFinite(numericRValue)) {
        if (numericRValue === 4.2) {
          rValue = '4.2';
        } else if (numericRValue === 6) {
          rValue = '6';
        } else if (numericRValue === 8) {
          rValue = '8';
        }
      }

      // Fallback to identifying the R-value from the item number.
      if (!rValue) {
        if (
          itemNo.includes('R4.2') ||
          itemNo.includes('R42')
        ) {
          rValue = '4.2';
        } else if (itemNo.includes('R6')) {
          rValue = '6';
        } else if (itemNo.includes('R8')) {
          rValue = '8';
        }
      }

      // Mobile Home coloring takes priority.
      if (productType === 'MH25') {
        classes.push('item-mobile-home');
      } else if (rValue === '4.2') {
        classes.push('item-r42');
      } else if (rValue === '6') {
        classes.push('item-r6');
      } else if (rValue === '8') {
        classes.push('item-r8');
      }

      // No B means carton.
      if (itemNo && !itemNo.includes('B')) {
        classes.push('item-carton');
      }

      return classes;
    },

    onDragStart(evt) {
      console.log('Drag started:', evt);

      const partNumber = evt.item.dataset.partNumber;
      const ord_qty = evt.item.dataset.ordQty;

      console.log('Part number:', partNumber);
      console.log('Order quantity:', ord_qty);

      const loc = String(this.$parent?.selectedLocation || '')
        .trim()
        .toUpperCase()
        .slice(0, 1);

      console.log('selectedLocation raw:', this.$parent?.selectedLocation);
      console.log('loc being sent:', loc);

      if (!loc) {
        console.error(
          'No location selected. Cannot proceed with work order creation.'
        );
        this.pendingWorkOrderPromise = null;
        return;
      }

      // Save the Promise so onDragEnd can wait for the WO number
      // if the user completes the drag before /create-work-order returns.
      this.pendingWorkOrderPromise = axios.post('/create-work-order', {
        machine: null,
        partNumber,
        ord_qty,
        loc,
        ord_status: 'U'
      })
      .then(response => {
        const workOrderNumber = parseInt(
          response.data.workOrderNumber,
          10
        );

        if (!Number.isInteger(workOrderNumber)) {
          throw new Error(
            `Invalid work order number returned: ${response.data.workOrderNumber}`
          );
        }

        console.log(
          'Work order created successfully:',
          workOrderNumber
        );

        evt.item.dataset.ordNo = workOrderNumber;

        console.log(
          'Assigned work order number to dataset:',
          evt.item.dataset.ordNo
        );

        return workOrderNumber;
      })
      .catch(error => {
        console.error(
          'Error creating work order:',
          error.response ? error.response.data : error.message
        );

        throw error;
      });
    },

    async onDragEnd(evt) {
      console.log('Drag ended for unscheduled orders');

      let machineElement = evt.to.closest('.machine-row');

      if (!machineElement) {
        const alternativeMachineElement = evt.to.parentElement.querySelector('.machine-header');
        if (alternativeMachineElement) {
          machineElement = alternativeMachineElement;
        } else {
          console.error('Failed to identify the machine element.');
          return;
        }
      }

      const toMachine = machineElement
        ? machineElement.querySelector('.machine-name').innerText.replace('Machine ', '')
        : null;

      if (!toMachine) {
        console.error('Target machine not identified.');
        return;
      }

      console.log('Dropped into machine:', toMachine);

      const partNumber = evt.item.dataset.partNumber;
      const bucket = evt.item.dataset.unscheduledBucket;
      let ord_no;

      try {
        // Wait for create-work-order if it hasn't completed yet.
        if (this.pendingWorkOrderPromise) {
          ord_no = await this.pendingWorkOrderPromise;
        } else {
          ord_no = parseInt(evt.item.dataset.ordNo, 10);
        }
      } catch (error) {
        console.error(
          'Cannot place work order because creation failed:',
          error
        );

        this.pendingWorkOrderPromise = null;
        return;
      }

      this.pendingWorkOrderPromise = null;

      console.log('Captured partNumber:', partNumber);
      console.log('Captured ord_no (from dataset):', ord_no, 'raw:', evt.item.dataset.ordNo);

      console.log('DROP CHECK:', {
        partNumber: evt.item.dataset.partNumber,
        ordQty: evt.item.dataset.ordQty,
        bucket: evt.item.dataset.unscheduledBucket,
        ordNoRaw: evt.item.dataset.ordNo
      });

      if (Number.isNaN(ord_no)) {
        console.error('Invalid work order number at drop time:', evt.item.dataset.ordNo);
        return;
      }

      const loc = String(this.$parent?.selectedLocation || '')
        .trim()
        .toUpperCase()
        .slice(0, 1);

      console.log('update selectedLocation raw:', this.$parent?.selectedLocation);
      console.log('update loc being sent:', loc);

      if (!['F', 'D', 'K', 'L'].includes(loc)) {
        console.error('Invalid location code for update:', loc);
        return;
      }

      const movedOrder = this.localUnscheduledOrders.find(order =>
        String(order.item_no || '').trim().toLowerCase() === String(partNumber || '').trim().toLowerCase() &&
        String(order.unscheduled_bucket || '').trim().toUpperCase() === String(bucket || '').trim().toUpperCase()
      );

      if (movedOrder) {
        movedOrder.orderId = ord_no;
        movedOrder.ord_no = ord_no;
        console.log('✅ Patched movedOrder with ord_no so locking can work immediately:', ord_no);
      } else {
        console.warn('⚠️ Could not find movedOrder in localUnscheduledOrders to patch:', partNumber);
      }

      // SortableJS newIndex is zero-based.
      // Pablo's run_sequence is one-based.
      const landedRunSequence =
        Number.isInteger(evt.newIndex)
          ? evt.newIndex + 1
          : null;

      console.log('UNSCHEDULED DROP POSITION:', {
        newIndex: evt.newIndex,
        run_sequence: landedRunSequence,
        machine: toMachine,
        ord_no
      });

      try {
        await axios.post('/update-work-order', {
          ord_no,
          machine: toMachine,
          loc,

          // NEW:
          // Tell backend exactly where scheduler dropped the Pending WO.
          run_sequence: landedRunSequence
        });

        console.log(
          `Order ${partNumber} updated to machine ${toMachine} ` +
          `at run sequence ${landedRunSequence}.`
        );
      } catch (error) {
        console.error(
          'Error updating work order:',
          error.response ? error.response.data : error.message
        );

        // Do NOT remove it from Unscheduled if persistence failed.
        return;
      }
      
      console.log('BEFORE REMOVE - child list summary:', {
        draggedPartNumber: partNumber,
        draggedBucket: bucket,
        total: this.localUnscheduledOrders.length,
        sales: this.localUnscheduledOrders.filter(o => String(o.unscheduled_bucket || '').toUpperCase() === 'SALES').length,
        salesPlus: this.localUnscheduledOrders.filter(o => String(o.unscheduled_bucket || '').toUpperCase() === 'SALES_PLUS').length,
        forecast: this.localUnscheduledOrders.filter(o => String(o.unscheduled_bucket || '').toUpperCase() === 'FORECAST').length,
        matchingItemRows: this.localUnscheduledOrders
          .map((o, idx) => ({
            idx,
            item_no: o.item_no,
            partNumber: o.partNumber,
            ord_qty: o.ord_qty,
            bucket: o.unscheduled_bucket,
            req_ship_dt: o.req_ship_dt,
            demand_bucket: o.demand_bucket
          }))
          .filter(o =>
            String(o.item_no || o.partNumber || '').trim().toLowerCase() ===
            String(partNumber || '').trim().toLowerCase()
          )
      });
      
      const orderIndex = this.localUnscheduledOrders.findIndex(order =>
        String(order.item_no || '').trim().toLowerCase() === String(partNumber || '').trim().toLowerCase() &&
        String(order.unscheduled_bucket || '').trim().toUpperCase() === String(bucket || '').trim().toUpperCase()
      );

      if (orderIndex !== -1) {
        console.log('REMOVING ROW DEBUG:', {
          draggedPartNumber: partNumber,
          draggedBucket: bucket,
          orderIndex,
          rowBeingRemoved: {
            item_no: this.localUnscheduledOrders[orderIndex]?.item_no,
            partNumber: this.localUnscheduledOrders[orderIndex]?.partNumber,
            ord_qty: this.localUnscheduledOrders[orderIndex]?.ord_qty,
            bucket: this.localUnscheduledOrders[orderIndex]?.unscheduled_bucket,
            req_ship_dt: this.localUnscheduledOrders[orderIndex]?.req_ship_dt,
            demand_bucket: this.localUnscheduledOrders[orderIndex]?.demand_bucket
          }
        });

        this.localUnscheduledOrders.splice(orderIndex, 1);

        console.log('AFTER REMOVE - child list summary:', {
          total: this.localUnscheduledOrders.length,
          sales: this.localUnscheduledOrders.filter(o => String(o.unscheduled_bucket || '').toUpperCase() === 'SALES').length,
          salesPlus: this.localUnscheduledOrders.filter(o => String(o.unscheduled_bucket || '').toUpperCase() === 'SALES_PLUS').length,
          forecast: this.localUnscheduledOrders.filter(o => String(o.unscheduled_bucket || '').toUpperCase() === 'FORECAST').length,
          remainingMatchingItemRows: this.localUnscheduledOrders
            .map((o, idx) => ({
              idx,
              item_no: o.item_no,
              partNumber: o.partNumber,
              ord_qty: o.ord_qty,
              bucket: o.unscheduled_bucket,
              req_ship_dt: o.req_ship_dt,
              demand_bucket: o.demand_bucket
            }))
            .filter(o =>
              String(o.item_no || o.partNumber || '').trim().toLowerCase() ===
              String(partNumber || '').trim().toLowerCase()
            )
        });

        this.$emit('update-unscheduled', this.localUnscheduledOrders);
        console.log('Updated unscheduled orders:', this.localUnscheduledOrders);
      }
    },

    showExplanation(order) {
      console.log('🧪 CLICKED ORDER raw:', order);
      console.log('🧪 CLICKED ORDER item_no:', order?.item_no);
      console.log('🧪 CLICKED ORDER bucket:', order?.unscheduled_bucket);
      console.log('🧪 CLICKED ORDER explanation_type:', order?.explanation_type);
      console.log('🧪 CLICKED ORDER explanation_summary:', order?.explanation_summary);
      console.log('🧪 CLICKED ORDER explanation_json:', order?.explanation_json);
      console.log('🧪 CLICKED ORDER keys:', Object.keys(order || {}));

      this.selectedOrder = order;

      try {
        this.selectedExplanation = order.explanation_json
          ? JSON.parse(order.explanation_json)
          : null;

        console.log('🧪 PARSED EXPLANATION:', this.selectedExplanation);
      } catch (err) {
        console.error('❌ Failed to parse explanation_json:', err);
        this.selectedExplanation = null;
      }

      this.showWhyModal = true;
    },

    closeExplanation() {
      this.showWhyModal = false;
      this.selectedExplanation = null;
      this.selectedOrder = null;
    },

    moveToTrash(partNumber) {
      const order = this.localUnscheduledOrders.find(order => order.item_no === partNumber);
      if (order) {
        this.$emit('move-to-trash', partNumber);
        const orderIndex = this.localUnscheduledOrders.findIndex(order => order.item_no === partNumber);
        if (orderIndex !== -1) {
          this.localUnscheduledOrders.splice(orderIndex, 1);
          this.$emit('update-unscheduled', this.localUnscheduledOrders);
        }
      }
    },

    onChange(event) {
      console.log('Change event:', event);
    }
  }
};
</script>


<style scoped>
.unscheduled {
  border: 1px solid #000;
  padding: 10px;
  margin: 10px 0;       /* remove horizontal margin so it fits its column */
  max-height: 80vh;
  overflow-y: auto;
  border-radius: 10px;
  box-sizing: border-box;
  background-color: #7affe276;
  max-width: 100%;      /* never spill outside its parent */
}


.draggable-container {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}

.work-order {
  border: 1px solid #ccc;
  padding: 5px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1 0 100px; /* Adjust width as needed */
  font-size: 12px;
  border-radius: 10px; /* Adds rounded corners */
  background-color: #f5f8f79a; /* Light Salmon background color for day boxes */
}

.work-order span {
  margin: 2px 0;
}

.day-boxes {
  display: flex;
  flex-direction: row;
  margin-top: 5px;
}

.day-box {
  width: 50px;
  margin-right: 5px;
  border: 1px solid #ccc;
  padding: 2px;
  text-align: center;
  border-radius: 5px; /* Adds slight rounding to day boxes */
}

.unscheduled-heading {
  color: #cbbfbf;; /* Example: Tomato color for the heading */
  font-family: Garamond, serif; /* Change the font family if desired */
}

.bucket-section {
  margin-bottom: 16px;
}

.bucket-heading {
  display: block;
  width: fit-content;
  margin: 8px auto;

  padding: 3px 8px;
  border-radius: 5px;

  background-color: rgba(255, 255, 255, 0.65);
  border: 1px solid rgba(17, 24, 39, 0.2);

  font-size: 16px;
  font-weight: 800;
  line-height: 1.15;
  text-align: center;

  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.15);
}

.sales-heading {
  color: #8b0000;
}

.sales-plus-heading {
  color: #0950b4;
}

.forecast-heading {
  color: #1f4e79;
}

.sales-plus-order {
  background-color: #fff3cd;
  border-color: #d97706;
}

.sales-plus-heading-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 4px;
}

.sales-plus-heading-row .bucket-heading {
  margin-bottom: 0;
}

.sales-plus-sort-control {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  white-space: nowrap;

  background-color: #dff3df;
  border: 1px solid #7aa77a;
  border-radius: 5px;
  padding: 3px 7px;
}

.sales-plus-sort-label {
  color: #4f6f4f;
  opacity: 0.65;
  font-weight: 600;
}

.sales-plus-sort-label.active {
  color: #174d17;
  opacity: 1;
  font-weight: 800;
}

.sales-plus-sort-switch {
  position: relative;
  display: inline-block;
  width: 38px;
  height: 20px;
  flex: 0 0 auto;
}

.sales-plus-sort-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.sales-plus-sort-slider {
  position: absolute;
  cursor: pointer;
  inset: 0;
  border: 1px solid #888;
  background: #ddd;
  border-radius: 20px;
}

.sales-plus-sort-slider::before {
  content: "";
  position: absolute;
  width: 14px;
  height: 14px;
  left: 2px;
  top: 2px;
  background: white;
  border: 1px solid #777;
  border-radius: 50%;
  transition: transform 0.15s ease;
}

.sales-plus-sort-switch input:checked + .sales-plus-sort-slider::before {
  transform: translateX(18px);
}


.why-button {
  align-self: center;
  margin-top: 3px;
  border: 1px solid #666;
  background: #fff8dc;
  border-radius: 50%;
  width: 22px;
  height: 22px;
  padding: 0;
  cursor: pointer;
  font-size: 12px;
  font-weight: 700;
  line-height: 20px;
  text-align: center;
}

.why-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}

.why-modal {
  background: white;
  border-radius: 12px;
  padding: 16px;
  width: 420px;
  max-width: 90vw;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
}

.why-summary {
  margin-top: 10px;
  padding-top: 8px;
  border-top: 1px solid #ddd;
}

.unscheduled-item-number {
  display: inline-block;
  align-self: center;
  width: fit-content;
  max-width: 100%;

  padding: 1px 4px;
  border-radius: 3px;

  background-color: rgba(255, 255, 255, 0.65);
  border: 1px solid rgba(17, 24, 39, 0.2);

  font-weight: 800;
  line-height: 1.1;
  text-align: center;

  text-shadow: none;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.15);
}

.unscheduled-detail {
  display: inline-block;
  align-self: center;
  width: fit-content;
  max-width: 100%;

  padding: 1px 5px;
  border-radius: 4px;

  color: #ffffff;
  background-color: rgba(17, 24, 39, 0.68);

  font-weight: 700;
  line-height: 1.15;
  text-align: center;

  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.18);
}

.unscheduled-qty {
  margin-top: 4px;
}

.max-inventory-warning {
  background-color: #b91c1c !important;
  color: #ffffff !important;
  border: 2px solid #7f1d1d !important;
  font-weight: 900;
}

.unscheduled-date {
  margin-top: 2px;
  font-size: 11px;
}

.unscheduled-meta {
  margin-top: 2px;
  font-size: 11px;
}

/* R-4.2 */
.item-r42 {
  color: #2563eb !important;
}

/* R-6 */
.item-r6 {
  color: #92400e !important;
}

/* R-8 */
.item-r8 {
  color: #15803d !important;
}

/* Mobile Home */
.item-mobile-home {
  color: #dc2626 !important;
}

/* Carton item: no B in item number */
.item-carton {
  font-style: italic !important;
}

</style>
